import { getApi } from "@/utils/fetch";
import { CitiesInfoResponse } from "@/utils/city";
import { PrefecturesInfoResponse } from "@/utils/prefecture";
import { TownsInfoResponse } from "@/utils/town";
import { ValuationAreaExtras } from "@/utils/contract";

export type AreaInfo = { id: number; name: string };

export type AreaInfoResponse = AreaInfo[];

const fetchPrefsAsync = async (
  abort: AbortController,
  contractId: number,
  control: ValuationAreaExtras | undefined
): Promise<PrefecturesInfoResponse> => {
  const params = new URLSearchParams();
  params.set("contractId", `${contractId}`);
  if (control) {
    params.set("control", control);
  }
  return getApi<PrefecturesInfoResponse>(`/api/area/prefs?${params.toString()}`);
};

const fetchCitiesAsync = async (
  abort: AbortController,
  contractId: number,
  prefId: number
): Promise<CitiesInfoResponse> => {
  const params = new URLSearchParams();
  params.set("contractId", `${contractId}`);
  params.set("prefId", `${prefId}`);
  return getApi<CitiesInfoResponse>(`/api/area/cities?${params.toString()}`);
};

const fetchTownsAsync = async (
  abort: AbortController,
  contractId: number,
  prefId: number,
  cityId: number
): Promise<TownsInfoResponse> => {
  const params = new URLSearchParams();
  params.set("contractId", `${contractId}`);
  params.set("prefId", `${prefId}`);
  params.set("cityId", `${cityId}`);
  return getApi<TownsInfoResponse>(`/api/area/towns?${params.toString()}`);
};

const fetchCitiesAllAsync = async (abort: AbortController, prefId: number): Promise<AreaInfoResponse> => {
  const params = new URLSearchParams();
  params.set("prefId", `${prefId}`);
  return getApi<AreaInfoResponse>(`/api/area/cities/all?${params.toString()}`);
};

const fetchTownsAllAsync = async (abort: AbortController, cityId: number): Promise<AreaInfoResponse> => {
  const params = new URLSearchParams();
  params.set("cityId", `${cityId}`);
  return getApi<AreaInfoResponse>(`/api/area/towns/all?${params.toString()}`);
};

const fetchLinesAsync = async (abort: AbortController, prefId: number): Promise<AreaInfoResponse> => {
  const params = new URLSearchParams();
  params.set("prefId", `${prefId}`);

  return getApi<AreaInfoResponse>(`/api/area/lines?${params.toString()}`);
};

const fetchStationsAsync = async (abort: AbortController, lineId: number): Promise<AreaInfoResponse> => {
  const params = new URLSearchParams();
  params.set("lineId", `${lineId}`);

  return getApi<AreaInfoResponse>(`/api/area/stations?${params.toString()}`);
};

export default {
  fetchPrefsAsync,
  fetchCitiesAsync,
  fetchTownsAsync,
  fetchCitiesAllAsync,
  fetchTownsAllAsync,
  fetchLinesAsync,
  fetchStationsAsync,
};
